import {useCallback, useEffect, useState} from "react";
import {useDebounceCallback} from "@react-hook/debounce";


type Node = Element | Window;


export function useBottomScrollListener(callback: () => void, offset: number, wait: number = 200, leading: boolean = true) {
    const [scrollNode, setScrollNode] = useState<Node>(null);

    const debounceCallback = useDebounceCallback(callback, wait, leading);

    const handleScroll = useCallback(() => {
        let scrollPosition, scrollContainerBottomPosition;
        if (scrollNode === window) {
            const scrollNode = document.scrollingElement || document.documentElement;
            scrollPosition = Math.round(scrollNode.scrollTop + window.innerHeight);
            scrollContainerBottomPosition = Math.round(scrollNode.scrollTop + window.innerHeight);
        } else if (scrollNode instanceof Element) {
            scrollPosition = Math.round(scrollNode.scrollHeight - offset);
            scrollContainerBottomPosition = Math.round(scrollNode.scrollTop + scrollNode.clientHeight);
        }

        if (scrollPosition <= scrollContainerBottomPosition) {
            debounceCallback();
        }
    }, [debounceCallback, scrollNode]);


    useEffect(() => {
        if (!scrollNode) {
            return
        }
        scrollNode.addEventListener("scroll", handleScroll);
        return () => {
            scrollNode.removeEventListener("scroll", handleScroll);
        }
    }, [scrollNode, handleScroll]);

    useEffect(() => {
        setScrollNode(window);
        return () => setScrollNode(null);
    }, [])

    return function<T extends Node>(node: T) {
        setScrollNode(node);
    }
}


export function findScrollableNode(node: Element) {
    while (node) {
        // const hasScrollableContent = node.scrollHeight > node.clientHeight;
        const scrollable = ["auto", "scroll"].includes(window.getComputedStyle(node).overflowY);
        if (scrollable) {
            return node;
        }
        node = node.parentElement;
    }
    return node || window;
}